export enum HoleDrillPileStatus {
  Log = 'Log',
  Entry = 'Entry',
  Start = 'Start',
  Paused = 'Pause',
  End = 'End',
  Failed = 'Failed',
  Continue = 'Continue'
}